module.exports = __webpack_public_path__ + "static/vitis-winemakers-c30d86deaf55f1a0f4e6d4348f478aac.png";